import type { LucideIcon } from 'lucide-react';

export interface TimelineEvent {
  icon: LucideIcon;
  label: string;
}

interface ApplicationTimelineProps {
  events: readonly TimelineEvent[];
}

export function ApplicationTimeline({ events }: ApplicationTimelineProps) {
  return (
    <div className="flex flex-col">
      {events.map((event, i) => {
        const isLast = i === events.length - 1;
        const Icon = event.icon;
        return (
          <div key={i} className="flex flex-col">
            <div className="flex items-center gap-3">
              <div className="flex size-8 shrink-0 items-center justify-center rounded-full border">
                <Icon className="size-4 text-muted-foreground" />
              </div>
              <span className="text-sm">{event.label}</span>
            </div>
            {!isLast ? (
              <div className="ml-4 h-6 border-l border-dashed border-muted-foreground/40" />
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
